// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyAtODDITsNEmB-bkIO1dhcYSJP6RT7oqow",
  authDomain: "formoney-b7d0a.firebaseapp.com",
  databaseURL: "https://formoney-b7d0a-default-rtdb.firebaseio.com",
  projectId: "formoney-b7d0a",
  storageBucket: "formoney-b7d0a.firebasestorage.app",
  messagingSenderId: "924512882179",
  appId: "1:924512882179:web:82bb1136b1f18695edc836"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
